// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kpi-card-details-box[data-v-29ef918c] {\n  border: 1px solid #d0d3d4;\n  border-radius: 8px;\n  background: #f7f9fa;\n}\n.row .col-3[data-v-29ef918c] {\n  height: auto;\n  width: 26%;\n  max-width: 100px;\n  padding: 8px;\n  margin: 0 13px 13px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
